import { gql } from '@apollo/client';

const TRANSMIT_QUOTE_DETAILS = gql`
    mutation transmitQuote($sfGuiQuoteId: String, $rmQuoteId: String, $tcsessionId: String!) {
        transmitQuote(input: { sfGuiQuoteId: $sfGuiQuoteId, rmQuoteId: $rmQuoteId, tcsessionId: $tcsessionId }) {
            status
            message
            data {
                status
                rentalmanQuoteId
                displayQuoteId
                recordType
                sfGuiQuoteId
                sfQuoteId
                transmitStatus
            }
        }
    }
`;
export default TRANSMIT_QUOTE_DETAILS;
